import { render, staticRenderFns } from "./StockySwitcher.vue?vue&type=template&id=43d88066&scoped=true"
import script from "./StockySwitcher.vue?vue&type=script&lang=ts"
export * from "./StockySwitcher.vue?vue&type=script&lang=ts"
import style0 from "./StockySwitcher.vue?vue&type=style&index=0&id=43d88066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d88066",
  null
  
)

export default component.exports